module.exports = __webpack_public_path__ + "static/media/i_64k.9bef0d37.mp3";